import React, { useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { FaWhatsapp } from 'react-icons/fa';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import WhatsAppFloat from '../../components/WhatsAppFloat';
import Icon from '../../components/AppIcon';
import SuccessMetricsSection from './components/SuccessMetricsSection';
import MonthlyChampionsSection from './components/MonthlyChampionsSection';
import VideoTestimonialCard from './components/VideoTestimonialCard';
import VideoModal from './components/VideoModal';
import WrittenReviewCard from './components/WrittenReviewCard';
import SocialProofSection from './components/SocialProofSection';
import { SITE, WA_MESSAGES, WHATSAPP_DISPLAY, openWhatsApp } from '../../config/site';

const VIDEO_STORIES = [
  {
    id: 1,
    name: 'Nisha Kumari',
    location: 'Mumbai, Maharashtra',
    avatar: '/assets/images/gen/avatar-nk.svg',
    videoUrl: '/videos/testimonial1.mp4',
    videoThumbnail: '/videos/thumbnails/testimonial1.jpg',
    winAmount: '₹2,50,000',
    game: 'Teen Patti Gold',
    category: 'card-games',
    quote:
      'Eight months here and the routine never changes — message the desk, get an answer in a minute, and the money lands before I finish my chai.',
    rating: 5,
    verified: true,
    playTime: '2:34',
  },
  {
    id: 2,
    name: 'Priya Sharma',
    location: 'Delhi, NCR',
    avatar: '/assets/images/gen/avatar-ps.svg',
    videoUrl: '/videos/testimonial2.mp4',
    videoThumbnail: '/videos/thumbnails/testimonial2.jpg',
    winAmount: '₹1,75,000',
    game: 'Andar Bahar Royal',
    category: 'card-games',
    quote:
      'The Nitin online book sign up took two minutes on WhatsApp, and the bankroll advice is the reason I am still ahead a year later.',
    rating: 5,
    verified: true,
    playTime: '3:12',
  },
  {
    id: 3,
    name: 'Amit Patel',
    location: 'Ahmedabad, Gujarat',
    avatar: '/assets/images/gen/avatar-ap.svg',
    videoUrl: '/videos/testimonial3.mp4',
    videoThumbnail: '/videos/thumbnails/testimonial3.jpg',
    winAmount: '₹4,20,000',
    game: 'Lightning Roulette',
    category: 'casino',
    quote:
      'I started at ₹500 a session. They taught me to read the wheel statistics instead of chasing losses — three months later I had crossed ₹4.2 lakh.',
    rating: 5,
    verified: true,
    playTime: '2:56',
  },
  {
    id: 4,
    name: 'Sneha Reddy',
    location: 'Hyderabad, Telangana',
    avatar: '/assets/images/gen/avatar-sr.svg',
    videoUrl: '/videos/testimonial4.mp4',
    videoThumbnail: '/videos/thumbnails/testimonial4.jpg',
    winAmount: '₹3,10,000',
    game: 'Dragon Tiger',
    category: 'casino',
    quote:
      'The app is what sold me. The Nitin online book app download link arrived instantly, installed clean, and has never dropped a session mid-hand.',
    rating: 5,
    verified: true,
    playTime: '2:18',
  },
];

const WRITTEN_REVIEWS = [
  {
    id: 1,
    name: 'Karan Tiwari',
    location: 'Lucknow, UP',
    avatar: '/assets/images/gen/avatar-kt.svg',
    game: 'Cricket Exchange',
    winAmount: '₹1,42,000',
    rating: 5,
    quote:
      'Cashed out mid-innings on a hunch and the money was in my UPI before the next over started. That kind of speed changes how you play.',
  },
  {
    id: 2,
    name: 'Deepa Singh',
    location: 'Bhopal, MP',
    avatar: '/assets/images/gen/avatar-ds.svg',
    game: 'Bollywood Mega Slots',
    winAmount: '₹84,500',
    rating: 5,
    quote:
      'I play small — ₹200 a night. Nobody treats me differently for it. Same support, same payout speed as the high rollers.',
  },
  {
    id: 3,
    name: 'Vikash Mehta',
    location: 'Patna, Bihar',
    avatar: '/assets/images/gen/avatar-vm.svg',
    game: 'Blackjack Premium',
    winAmount: '₹96,000',
    rating: 5,
    quote:
      'They sent me a basic-strategy chart for free and told me to stop doubling on 12. Cost them money, saved me plenty. That is trust.',
  },
  {
    id: 4,
    name: 'Harsh Pandey',
    location: 'Nagpur, Maharashtra',
    avatar: '/assets/images/gen/avatar-hp.svg',
    game: 'Rocket Crash',
    winAmount: '₹3,18,000',
    rating: 5,
    quote:
      'Provably fair hashes I can verify myself. I checked six rounds at random before I trusted it — every one matched.',
  },
  {
    id: 5,
    name: 'Anjali Rao',
    location: 'Kolkata, West Bengal',
    avatar: '/assets/images/gen/avatar-ar.svg',
    game: 'Royal Wheel Draw',
    winAmount: '₹12,00,000',
    rating: 5,
    quote:
      'A ₹10 ticket. I did not believe the message until the bank SMS arrived twelve minutes later. I still have the screenshot.',
  },
  {
    id: 6,
    name: 'Sana Gill',
    location: 'Chandigarh, Punjab',
    avatar: '/assets/images/gen/avatar-sg.svg',
    game: 'Baccarat VIP',
    winAmount: '₹5,40,000',
    rating: 5,
    quote:
      'My VIP manager knows my limits and actually enforces them. Being told “that is enough for tonight” is why I still play here.',
  },
];

const FILTERS = [
  { id: 'all', label: 'All stories', icon: 'LayoutGrid' },
  { id: 'card-games', label: 'Card games', icon: 'Spade' },
  { id: 'casino', label: 'Live casino', icon: 'Dices' },
];

const SuccessStoriesGallery = () => {
  const [filter, setFilter] = useState('all');
  const [activeVideo, setActiveVideo] = useState(null);

  const stories = useMemo(
    () => (filter === 'all' ? VIDEO_STORIES : VIDEO_STORIES.filter((s) => s.category === filter)),
    [filter]
  );

  return (
    <>
      <Helmet>
        {/* Deindexed: keep site reachable directly, but out of search results. */}
        <meta name="robots" content="noindex, nofollow, noarchive, nosnippet, noimageindex" />
        <meta name="googlebot" content="noindex, nofollow, noarchive, nosnippet, noimageindex" />
        <title>Success Stories &amp; Winner Showcase | Nitin Online Book | Nitin Online Book</title>
        <meta
          name="description"
          content="Real winner stories from Nitin Online Book and Nitin Online Book — verified payouts, video testimonials and player reviews. See how Indian players win with instant payouts and 24/7 WhatsApp support."
        />
        <meta
          name="keywords"
          content="Nitin Online Book winners, Nitin Online Book reviews, success stories, verified payouts, gaming testimonials, Nitin online book review, instant payouts India, teen patti winners, cricket betting winners"
        />
        <meta property="og:title" content="Success Stories & Winner Showcase | Nitin Online Book | Nitin Online Book" />
        <meta
          property="og:description"
          content="Verified winners, real payouts and honest reviews from the Nitin Online Book community."
        />
        <meta property="og:image" content={`${SITE.url}/assets/images/gen/winners-banner.svg`} />
        <meta property="og:url" content={`${SITE.url}/success-stories-gallery-winner-showcase`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={SITE.name} />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Success Stories & Winner Showcase | Nitin Online Book" />
        <meta
          name="twitter:description"
          content="Verified winners, real payouts and honest reviews from the Nitin Online Book community."
        />
        <meta name="twitter:image" content={`${SITE.url}/assets/images/gen/winners-banner.svg`} />
        <link rel="canonical" href={`${SITE.url}/success-stories-gallery-winner-showcase`} />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE.url}/` },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Winners',
                item: `${SITE.url}/success-stories-gallery-winner-showcase`,
              },
            ],
          })}
        </script>
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />

        {/* Hero */}
        <section className="relative isolate overflow-hidden py-16 lg:py-24">
          <span className="aurora left-[-10%] top-[-4%] h-[26rem] w-[26rem] bg-wa-green/25" aria-hidden="true" />
          <span className="aurora right-[-8%] top-[12%] h-[26rem] w-[26rem] bg-royal-gold/25" aria-hidden="true" />
          <div className="absolute inset-0 grid-lines" aria-hidden="true" />

          <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
            <span className="badge-pill"><Icon name="Trophy" size={13} /> Winners circle</span>
            <h1 className="mt-6 font-heading text-hero font-bold text-white [text-wrap:balance]">
              ₹12 crore paid out. <span className="gold-text">Here are the faces.</span>
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-body-lg text-white/65">
              Every story below is tied to a real transaction and published with the player&apos;s permission.
              Filmed on their phones, not ours — a winner explaining a five-minute payout says more than any
              advertisement we could write.
            </p>

            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <button onClick={() => openWhatsApp(WA_MESSAGES.newId)} className="btn-3d btn-3d-wa">
                <FaWhatsapp size={19} /> Write your own story
              </button>
              <span className="text-sm text-white/45">Direct line · {WHATSAPP_DISPLAY}</span>
            </div>
          </div>
        </section>

        <SuccessMetricsSection />
        <MonthlyChampionsSection />

        {/* Video gallery */}
        <section className="relative overflow-hidden py-24">
          <span className="aurora right-[-8%] top-[16%] h-96 w-96 bg-royal-violet/25" aria-hidden="true" />

          <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl text-center">
              <span className="badge-pill"><Icon name="Video" size={13} /> Video stories</span>
              <h2 className="mt-6 font-heading text-display font-bold text-white">
                Watch them <span className="gold-text">tell it themselves</span>
              </h2>
              <p className="mt-4 text-body-lg text-white/60">
                Four players, four games, one common thread — the desk answered and the money moved.
              </p>
            </div>

            <div className="mt-10 flex flex-wrap justify-center gap-2">
              {FILTERS.map((f) => (
                <button
                  key={f.id}
                  onClick={() => setFilter(f.id)}
                  className={`flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium transition ${
                    filter === f.id
                      ? 'bg-gradient-royal text-[#150F02]'
                      : 'border border-white/10 bg-white/[0.05] text-white/60 hover:text-white'
                  }`}
                >
                  <Icon name={f.icon} size={15} /> {f.label}
                </button>
              ))}
            </div>

            <div className="perspective mt-10 grid gap-6 md:grid-cols-2">
              {stories.map((s, i) => (
                <div key={s.id} className="animate-rise" style={{ animationDelay: `${i * 70}ms` }}>
                  <VideoTestimonialCard testimonial={s} onPlay={setActiveVideo} />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Written reviews */}
        <section className="relative overflow-hidden py-24">
          <span className="aurora left-[-8%] top-[10%] h-96 w-96 bg-royal-gold/20" aria-hidden="true" />

          <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl text-center">
              <span className="badge-pill"><Icon name="PenLine" size={13} /> Player reviews</span>
              <h2 className="mt-6 font-heading text-display font-bold text-white">
                Six more, from <span className="gold-text">six different cities</span>
              </h2>
              <p className="mt-4 text-body-lg text-white/60">
                Big wins and small ones. The ₹200-a-night player gets the same desk as the VIP table.
              </p>
            </div>

            <div className="perspective mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {WRITTEN_REVIEWS.map((r, i) => (
                <div key={r.id} className="animate-rise h-full" style={{ animationDelay: `${i * 60}ms` }}>
                  <WrittenReviewCard review={r} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <SocialProofSection />

        {/* Closing CTA */}
        <section className="relative overflow-hidden pb-24">
          <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
            <div className="panel-gold shine-hover overflow-hidden px-6 py-12 text-center sm:px-12">
              <h2 className="font-heading text-3xl font-bold text-white sm:text-4xl">
                Your name could be on this page <span className="gold-text">next month</span>
              </h2>
              <p className="mx-auto mt-4 max-w-2xl text-white/60">
                Every winner here started the same way: one message, one ID, one sensible limit. The desk does the
                rest — sign up, strategy pack, and a payout that actually arrives.
              </p>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <button onClick={() => openWhatsApp(WA_MESSAGES.newId)} className="btn-3d btn-3d-wa">
                  <FaWhatsapp size={19} /> Claim my gaming ID
                </button>
                <button onClick={() => openWhatsApp(WA_MESSAGES.strategy)} className="btn-3d btn-3d-ghost">
                  <Icon name="Brain" size={17} /> Get the strategy pack
                </button>
              </div>
            </div>
          </div>
        </section>

        <Footer />
        <WhatsAppFloat />
      </div>

      <VideoModal testimonial={activeVideo} isOpen={Boolean(activeVideo)} onClose={() => setActiveVideo(null)} />
    </>
  );
};

export default SuccessStoriesGallery;
